import React from "react";
import styled from "styled-components";
import { bool, func } from "prop-types";

const StyledBurger = styled.label`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 2rem;
  height: 2rem;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  margin-right: 2rem;
  outline: none;

  @media (min-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
    display: none;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    margin-right: 1rem;
  }

  &:focus {
    outline: none;
  }

  div {
    width: 2rem;
    height: 0.25rem;
    background: ${({ theme, $transparentHeader, $burgerOpen }) =>
      $transparentHeader && !$burgerOpen
        ? theme.colors.transparentHeaderTextColor
        : theme.colors.headerLink || theme.colors.black};
    border-radius: 15px;
    transition: all 0.3s linear;
    position: relative;
    transform-origin: 1px; /* Rotate from the left */
    z-index: 99;
  }

  /* First line rotates to form part of the X */
  div:first-child {
    transform: ${({ $burgerOpen }) =>
      $burgerOpen ? "rotate(45deg)" : "rotate(0)"};
  }

  /* Middle line fades out when burger is open */
  div:nth-child(2) {
    opacity: ${({ $burgerOpen }) => ($burgerOpen ? "0" : "1")};
    transform: ${({ $burgerOpen }) =>
      $burgerOpen ? "translateX(20px)" : "translateX(0)"};
    width: 2rem;
  }

  /* Last line rotates to form part of the X */
  div:nth-child(3) {
    transform: ${({ $burgerOpen }) =>
      $burgerOpen ? "rotate(-45deg)" : "rotate(0)"};
  }
`;

const Burger = ({ burgerOpen, setBurgerOpen, transparentHeader }) => {
  return (
    <StyledBurger
      $transparentHeader={transparentHeader}
      $burgerOpen={burgerOpen}
      onClick={() => setBurgerOpen(!burgerOpen)}
    >
      <div />
      <div />
      <div />
    </StyledBurger>
  );
};

Burger.propTypes = {
  burgerOpen: bool.isRequired,
  setBurgerOpen: func.isRequired,
  transparentHeader: bool,
};
export default Burger;
